"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openSidePanel = openSidePanel;
exports.closeSidePanel = closeSidePanel;
exports.openPreviousSidePanel = openPreviousSidePanel;
exports.isSidePanelOpen = isSidePanelOpen;
/**
 * В АМ-вебью СП открываются на основе query в URL. При пуше в историю, все query очищаются.
 * @param params параметры сайд-панели
 * @param queryNames список query, которые нужно оставить, при пуше в историю
 */
function openSidePanel(params, queryNames) {
    if (typeof window !== 'undefined' && window.openSidePanel) {
        window.openSidePanel(params, queryNames);
    }
}
function closeSidePanel() {
    if (typeof window !== 'undefined' && window.closeSidePanel) {
        window.closeSidePanel();
    }
}
function openPreviousSidePanel() {
    if (typeof window !== 'undefined' && window.openPreviousSidePanel) {
        window.openPreviousSidePanel();
        return true;
    }
    return false;
}
function isSidePanelOpen() {
    if (typeof window !== 'undefined') {
        return window.isSidePanelOpen;
    }
    return undefined;
}
